import React from 'react'
import MenuSelection from '../../Components/MenuSelection/MenuSelection'
import MenuTitlle from '../../Components/MenuTitlle/MenuTitle'
import Style from './ManageDiscount.module.css'
const ManageDiscount = () => {
    const colors=[
        '#EEEEEE',
        '#FFFBDE',
        '#E5FFF1'
    ]
    const menuValue=[
        {
            src:'/Assets/Images/MenuDiscount/1.png',
            title:'تخفیف کل محصولات',
            link:'/allproduct'
        },
        {
            src:'/Assets/Images/MenuDiscount/2.png',
            title:'تخفیف یک دسته بندی',
            link:'/category'
        },
        {
            src:'/Assets/Images/MenuDiscount/3.png',
            title:'تخفیف یک محصول',
            link:'/oneproduct'
        }
    ]
    return (
        <div className={Style.pageHolder}>
            <MenuTitlle title={"مدیریت تخفیف"}/>
            <ul className={Style.MeniPartHolder}>
                {
                    menuValue.map((item,index)=>{
                        return(
                            <li key={index} className={Style.MeniPartHolder__EachPart} style={{background:colors[index]}}>
                                <MenuSelection linkholder={item.link} Imgsrc={item.src} title={item.title}/>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}
export default ManageDiscount
